import React from "react";

export function InformationIcon() {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg">
            <path d="M43.333 30h-6.666v-6.667h6.666V30zm0 26.667h-6.666v-20h6.666v20zm-3.3 16.666c18.4 0 33.3-14.933 33.3-33.333s-14.9-33.333-33.3-33.333C21.6 6.667 6.667 21.6 6.667 40S21.6 73.333 40.033 73.333zm-.033-60c14.733 0 26.667 11.934 26.667 26.667 0 14.733-11.934 26.667-26.667 26.667-14.733 0-26.667-11.934-26.667-26.667 0-14.733 11.934-26.667 26.667-26.667z" fill="#D8E2EC" fillRule="evenodd"/>
        </svg>
    );
}
